import React, { MutableRefObject } from "react";
import {useStoreRoom, useStoreSystem} from "../../../store";
import DecorObject from "./components/DecorObject";
import shallow from "zustand/shallow";
import {oppositeSides} from "../../../store/types/store";
import { GLTFResult } from "../room/ImportedRoom";

interface DecorsListProps {
    moveCameraEnabled: MutableRefObject<boolean>;
    gltfRoom: GLTFResult;
}

const DecorsList: React.FC<DecorsListProps> = React.memo((props) => {
    const { moveCameraEnabled } = props

    const decors = useStoreRoom((state) => state.decors, shallow);
    const isPdfPreparation = useStoreSystem(state => state.isPdfPreparation)
    const currentSide = useStoreSystem(state => state.currentSide)

    return (
        <group>
            {decors.map((decor) => {
                if ((decor.side === oppositeSides[currentSide] && decor.surface === 'wall') && !isPdfPreparation) {
                    return
                }
                return (
                    <DecorObject
                        key={decor.id}
                        decor={decor}
                        gltfRoom={props.gltfRoom}
                        moveCameraEnabled={moveCameraEnabled}
                    />
                )
            })}
        </group>
    );
})

export default DecorsList
